import React from 'react';
import { NavbarTabs } from 'common/enums';
import { classnames } from 'helpers/utils';
import styles from './navbar-tab.module.scss';

type NavbarTabProps = {
  tab: NavbarTabs;
  label: string;
  selectedTab: NavbarTabs;
  onClick: () => void;
  icon: React.ReactNode;
};

const NavbarTab = ({
  tab,
  label,
  selectedTab,
  onClick,
  icon,
}: NavbarTabProps) => {
  const isCurrent = selectedTab === tab;
  return (
    <button
      type="button"
      className={classnames(styles.tab, { [styles.current]: isCurrent })}
      onClick={onClick}
      aria-current={isCurrent ? 'page' : undefined}
    >
      <span className={styles.icon}>{icon}</span>
      <span className={styles.label}>{label}</span>
    </button>
  );
};

export { NavbarTab };
